var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ProfileBox,{attrs:{"profile":_setup.profile,"size":_vm.size,"hideBadge":_vm.hideBadge,"isBadgeInline":_vm.isBadgeInline,"hideAllBadges":_vm.hideAllBadges},on:{"authorClick":function($event){return _vm.$emit('authorClick', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }